import { useDeviceUpload } from "client/hooks/upload/useDeviceUpload";
import { HandleFile } from "client/types/HandleFile";
import { UploadOptions } from "client/types/UploadOptions";
import { DeviceIcon } from "components/common/Icons/DeviceIcon";
import { Translate } from "components/common/Translate/Translate";

export interface DeviceUploadProps {
    handleFile: HandleFile;
    htmlFileInputId: string;
    options: UploadOptions;
}

export const DeviceUpload = ({ handleFile, options, htmlFileInputId }: DeviceUploadProps) => {
    const { handleClick } = useDeviceUpload(handleFile, options, htmlFileInputId);

    return (
        <div
            className="flex items-center gap-2 py-3.5 pl-4 pr-12 hover:bg-gray-200 dark:hover:bg-darkSurface-300"
            onClick={(e) => {
                e.stopPropagation();
                options.onClick && options.onClick();
                handleClick();
            }}
            data-testid="device-upload"
        >
            <DeviceIcon height={14} width={14} />
            <div className="capitalize">
                <Translate keyName="from-device" />
            </div>
        </div>
    );
};
